// extracted by mini-css-extract-plugin
export var chip = "_5n-9";
export var chipLabel = "_5n-a";
export var close = "_5n-7";
export var closeIcon = "_5n-8";
export var error = "_5n-6";
export var infoTooltip = "_5n-2";
export var innerContainer = "_5n-1";
export var input = "_5n-b";
export var medium = "_5n-5";
export var outerContainer = "_5n-0";
export var small = "_5n-4";
export var xSmall = "_5n-3";